import BaseService from './base';

export interface BookViewModel {
  id?: number;
  courseID?: number;
  title?: string;
  alias?: string;
  press?: string;
  pressDate?: Date;
  volume?: string;
  author?: string;
  introduce?: string;
  location?: string;
  reader?: string;
  guidance?: string;
  evaluation?: string;
  icon?: string;
  status?: number;
  displayPos?: number;
}

export  class BookService extends BaseService<BookViewModel> {
  protected serviceApi: string = 'Book';

  get NewModel(): BookViewModel {
    return {
      id: 0,
      title: '',
      status: 1,
    };
  }

  public GetBookTree() {
    return super.GetUrl('/GetBookTree');
  }
  public GetByGuid(guid: string) {
    return super.GetUrl(`/GetByGuid/${guid}`);
  }
}
